// Affiliate features (earning commissions, share-to-earn, leaderboard, etc.)
// are only visible to users who have signed up as sellers. Customers see
// products and prices like a normal shopper. Admins also see affiliate UI
// for moderation purposes.
export function canSeeAffiliateUI(user) {
  return !!user && (user.role === "seller" || user.role === "admin");
}
